module.exports = __webpack_public_path__ + "img/Webで学ぶ JavaScript 2020_2_4_4.9b5cef34.jpeg";